import PropTypes from 'prop-types';
import React from 'react';
import '../styles/icon-library.css';
import '../styles/web-fonts.css';
import '../styles/utilities.css';

/*!

   FORKED AND CHANGED

   Flowplayer.min.js file was modified from the original v7.0.4 to include change for Android detection.

   CHANGED

   (\d\.\d) became (\d+(\.\d+)?)

   IF THIS FILE IS UPDATED IT MUST BE TO VERSION 7.2.7 or later

*/

class Styles extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default Styles;
